<template>
  <div class="mb-4">
    <h6 class="fw-bold mb-3">
      Géomètre expert
    </h6>
    <div class="row">
      <div class="col-12 mb-3">
        <label class="form-label">Numéro d'enregistrement</label>
        <input
          v-model="surveyorNumber"
          type="text"
          class="form-control"
          :class="touchedField ? `is-${isSurveyorNumberValid ? 'valid' : 'invalid'}` : ''"
          placeholder="Entrez le numéro d'enregistrement"
          @blur="touchedField = true"
        >
        <div
          v-if="touchedField && !isSurveyorNumberValid"
          class="invalid-feedback"
        >
          Le numéro d'enregistrement est requis
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash-es';

export default {
  name: 'ComplementarySurveyorForm',
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  emits: ['validation'],
  data() {
    return {
      surveyorNumber: '',
      touchedField: false,
    };
  },
  computed: {
    isSurveyorNumberValid() {
      if (this.surveyorNumber.length === 0) return false;
      return this.surveyorNumber.trim().length > 0;
    },
    hasError() {
      return !this.isSurveyorNumberValid;
    },
  },
  watch: {
    hasError: {
      immediate: true,
      handler(val) {
        this.$emit('validation', !val);
      },
    },
  },
  mounted() {
    this.surveyorNumber = get(this.contract, 'risk.surveyorNumber', '');
  },
  methods: {
    async submit() {
      return { surveyorNumber: this.surveyorNumber };
    },
  },
};
</script>
